<template>
    <div :class="count < 100 ? 'pc_loading' : 'pc_page'" id="pc_page">
    <!-- <div class="pc_loading" id="pc_page"> -->
        <!-- 活动标题 -->
        <div class="wechat-title" v-wechat-title="'魔卡少女樱：回忆钥匙'"></div>
        <div class="title"></div>
        <div class="logo"></div>
        <div class="box">
            <div class="qrcode-box">
                <div id="qrcode" class="qrcode"></div>
            </div>
        </div>

        <div class="loading" v-if="count < 100">

            <div class="loading_line right_line"></div>
            <div class="loading_logo"></div>
            <div class="loading_line left_line"></div>

            <div class="loading_text">
                <div class="loading_count">
                    LOADING&nbsp;{{ count }}%</div>
            </div>
        </div>
    </div>
</template>
<script>
import { getRandomString } from '@/utils/utils';
export default {
    name: 'anniversary',
    data() {
        return {
            count: 0
        }
    },
    created() {
        var userAgent = navigator.userAgent.toLowerCase();
        var isPC = userAgent.indexOf('windows') > -1 || userAgent.indexOf('macintosh') > -1;
        if (isPC) {
            console.log('当前设备是 PC');
        } else {
            this.$router.push(`enter${getRandomString()}`);
            console.log('当前设备不是 PC');
        }
    },
    mounted() {
        this.incrementTo100()
    },
    methods: {
        incrementTo100() {
            const target = 100;
            const duration = 700; // 持续时间1秒
            const stepTime = duration / target; // 每一步的时间间隔
            const intervalId = setInterval(() => {
                this.count += 1;
                if (this.count >= target) {
                    clearInterval(intervalId); // 当达到100时停止计时器
                }
            }, stepTime);
        },
    }
}
</script>
<style lang="less">
@import url("./pc.less");
</style>


// WEBPACK FOOTER //
// src/pages/sakura/card/pc/index.vue